{
  "staticPageWidgetSettings": "Paramètres du widget de page fixe",
  "addWidget": "Ajouter un widget",
  "editWidget": "Modifier le widget",
  "addTab": "Ajouter un onglet",
  "editTab": "Modifier l'onglet",
  "ruleGroupError": "Veuillez remplir tous les champs du règlement.",
  "editCode": "Modifier le code",
  "copy": "Copier la configuration de page",
  "archive": "Archive",
  "paste": "Coller la page de configuration",
  "pageTypeMismatch": "Le type de page ne correspond pas",
  "pageUpdated": "Page mise à jour",
  "pageConfigIssues": "Page mise à jour, mais avec des avertissements",
  "characterLimit": "Limite de 50 caractères",
  "goalWorkflowNotFound": "Le flux de travail d'objectifs sur le widget {{widgetType}}, dans l'onglet « {{tab}} », n'a pas été trouvé dans cette organisation, il a été supprimé de la configuration.",
  "householdWorkflowNotFound": "Le flux de travail de ménages sur le widget {{widgetType}}, dans l'onglet « {{tab}} », n'a pas été trouvé dans cette organisation, il a été supprimé de la configuration.",
  "customFieldNotFound": "Le champ personnalisé « {{customField}} » sur le widget {{widgetType}}, dans l'onglet « {{tab}} », n'a pas été trouvé dans cette organisation, il a été supprimé de la configuration.",
  "pasteWarning": "En tant que fonction bêta, le collage de configurations de pages peut poser des problèmes. Veuillez l'utiliser avec précaution et la tester d'abord dans un environnement sécurisé.",
  "addLinkTab": {
    "switch": "Activer le lien",
    "label": "Lien externe",
    "error": "URL invalide"
  },
  "editPage": {
    "button": "Modifier",
    "title": "Modifier la page",
    "options": {
      "greeting": "Salutation",
      "enableAddingAccountToHousehold": "Permettre l'ajout d'un compte à un ménage ou à partir d'un ménage",
      "enableAddingGoalToHousehold": "Permettre l'ajout d'un objectif à un ménage ou à partir d'un ménage",
      "addContent": "Ajouter du contenu",
      "showUpcomingMaintenanceSchedule": "Afficher le calendrier des travaux à venir",
      "contentDescriptionBanner": "Bannière de description du contenu (50 caractères max.)",
      "contentDescriptionBannerError": "La description ne doit pas comporter plus de 50 caractères",
      "contentDescriptionTitle": "Titre de la description du contenu",
      "contentDescription": "Description du contenu web",
      "deposit": "Dépôt",
      "withdraw": "Retrait",
      "canEditHouseholdName": "Modification du nom du ménage possible",
      "enableClosingHousehold": "Activer la clôture d'un ménage",
      "canCloseGoal": "Peut fermer l'objectif",
      "canCloseSubAccount": "Peut fermer le sous-compte",
      "canCloseAccount": "Autoriser la fermeture du compte",
      "canForceOpenAccount": "Autoriser l'ouverture forcée du compte",
      "canViewAccountStateHistory": "Voir l'historique de l'état du compte",
      "enableAccountEditing": "Autoriser la modification du compte",
      "nickName": "Surnom",
      "repCode": "Code représentant",
      "state": "Statut du compte",
      "custodianAccountNumber": "Numéro de compte",
      "dealerCode": "Code courtier",
      "dealerName": "Nom du courtier",
      "dealerAccountNumber": "Numéro de compte courtier",
      "canTriggerWorkflows": "Peut déclencher des flux de travail",
      "canChangeOrganization": "Peut changer d'organisation",
      "canChangeHousehold": "Peut changer de ménage",
      "removeFromHousehold": "Retirer du ménage",
      "addToHousehold": "Ajouter au ménage",
      "canFreezeClient": "Peut geler le client",
      "canDeactivateClient": "Peut désactiver le client",
      "displayOrganizationName": "Afficher le nom de l'organisation",
      "maxPageWidth": "Largeur de page maximale",
      "enableSubAccountEditing": "Activer la modification des sous-comptes",
      "goal": "Objectif",
      "portfolioTheme": "Thème du portefeuille",
      "modelPortfolio": "Portefeuille modèle",
      "tradingProcess": "Processus de négociation",
      "subAccountState": "Statut du sous-compte",
      "requireInvestorPolicyStatement": "Exiger une déclaration de politique d'investisseur",
      "allowFractionalShares": "Autoriser les actions fractionnaires",
      "allowClientDeposits": "Autoriser les dépôts clients",
      "subAccountLiquidated": "Sous-compte liquidé",
      "enableAccountGroupEditing": "Activer la modification des groupes de comptes",
      "canDeleteAccountGroup": "Peut supprimer le groupe de comptes",
      "defaultDepositWorkflow": {
        "label": "-"
      },
      "canAddCurrency": "Permettre l'ajout d'une devise"
    }
  },
  "widgetType": "Type",
  "add": "Ajouter",
  "update": "Mettre à jour",
  "save": "Enregistrer",
  "hidden": "Masqué",
  "saveSuccessMessage": "Configuration de la page enregistrée",
  "untitled": "Sans titre",
  "saveStaticPageWidgetSuccessMessage": "Configuration du widget de page statique enregistrée",
  "label": "Étiquette de l'onglet",
  "icon": "Icône",
  "listOfIcons": "Liste des icônes",
  "deleteTab": "Supprimer l'onglet",
  "viewFor": "Afficher pour",
  "pageName": "Nom de la page",
  "noReports": "Aucun rapport disponible pour la période sélectionnée.",
  "selectViewFor": "Sélectionnez un client pour visualiser cette configuration de page",
  "deposit": "Dépôt",
  "withdraw": "Retrait",
  "options": "Options",
  "notEditableMessage": "Pour apporter des modifications, veuillez communiquer avec l'assistance.",
  "widgetTypes": {
    "CLIENT_NAME": "Nom du client",
    "MARKET_VALUE_CHART": "Graphique de la valeur du marché",
    "ACCOUNTS": "Comptes",
    "GOALS": "Objectifs",
    "GOALS_AND_ACCOUNTS": "Objectifs et comptes",
    "SUB_ACCOUNTS": "Sous-comptes",
    "HOLDINGS": "Actifs",
    "DOCUMENTS": "Documents",
    "LEDGER": "Grand livre",
    "INITIATE_TRANSFER": "Initier le transfert",
    "SCHEDULED_TRANSFERS": "Virements programmés",
    "UPCOMING_TRANSACTIONS": "Transactions en attente",
    "NON_INDIVIDUAL_INFORMATION": "Informations non individuelles",
    "PERSONAL_INFORMATION": "Renseignements personnels",
    "RELATIONSHIP_INFORMATION": "Informations sur les relations",
    "EMPLOYMENT_INFORMATION": "Situation professionnelle",
    "RESIDENCY_INFORMATION": "Informations sur la résidence",
    "PERSONS_OF_INTEREST": "Personnes d'intérêt",
    "INCOME_ASSETS_AND_DEBTS": "Revenus, actifs et dettes",
    "SUITABILITY": "Adéquation",
    "GOAL_SUITABILITY": "Adéquation de l'objectif",
    "ID_VERIFICATION": "Preuve d'identité",
    "NEWS_AND_INSIGHTS": "Actualités et analyses (à des fins de démonstration uniquement)",
    "RECENT_TRANSACTIONS": "Transactions récentes",
    "EDIT_ACCOUNT": "Modifier le compte",
    "REFINITIV": "Refinitiv",
    "ACCESS": "Accorder l'accès",
    "SEARCH_SECURITIES": "Rechercher les valeurs mobilières",
    "ADVISOR_CONTACT_INFORMATION": "Coordonnées du conseiller",
    "PROJECTED_INCOME_REPORT": "Revenu projeté",
    "NOTES": "Notes",
    "AUDIT_LOG": "Journal d'audit",
    "TRADE_ORDERS": "Ordres de transaction",
    "FEE_DETAILS": "Détails des frais",
    "HOUSE_HOLD_MEMBERS": "Membres",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Vérifier les informations du compte bancaire",
    "COMPLIANCE": "Conformité",
    "PORTFOLIO": "Portefeuille",
    "HOUSEHOLD_MODEL_PORTFOLIO": "Portefeuille modèle du ménage",
    "TRANSFERS": "Virements",
    "RELATIONSHIPS": "Relations",
    "FREE_FORM_INPUT": "Saisie libre",
    "RATE_OF_RETURNS": "Taux de retours",
    "MODEL_PORTFOLIO_HOLDINGS": "Actifs du portefeuille de modèles",
    "BULK_TRADE_REQUESTS": "Demandes d'opérations groupées",
    "GOAL_INFORMATION": "Renseignements sur l'objectif",
    "NEXT_BEST_ACTION": "Meilleure action suivante (bêta)",
    "CUSTOM_FIELDS_DISPLAY": "Affichage des champs personnalisés",
    "MARKET_DATA_TICKER": "Téléscripteur de données boursières",
    "NET_WORTH": "Valeur nette (Bêta)",
    "FEES_AND_REVENUE": "Frais et revenus",
    "AUM_EXPLORER": "Explorateur AUM",
    "PRACTICE_OVERVIEW": "Aperçu de la pratique",
    "QUICK_LINKS": "Liens rapides",
    "NETFLOWS": "Flux nets",
    "OPEN_WORKFLOWS": "Flux de travail ouverts",
    "PENDING_TRANSACTIONS": "Transactions en attente",
    "REPORT": "Rapports",
    "DATA_WIDGET": "Widget de données",
    "CONFIGURABLE_TABLE_WIDGET": "Widget de table configurable",
    "ACCOUNT_GROUPS": "Groupes de comptes",
    "PRODUCT_AUM_EXPOSURE": "Exposition de l'AUM par produit"
  },
  "refinitiv": {
    "securityDetails": "Détails de la valeur mobilière",
    "newsHeadlines": "Titres des nouveautés",
    "estimatesRatios": "Estimations et ratios",
    "fundAllocation": "Allocation des fonds",
    "fundAverageAnnualReturns": "Rendements annuels moyens du fonds",
    "priceYield": "Rendement des prix",
    "fundObjective": "Objectif du fonds"
  },
  "error": {
    "invalidIconErrorText": "Veuillez entrer une valeur en notation serpent, par exemple : solde_compte",
    "maxLengthError": "Doit contenir {{max}} caractères ou moins"
  },
  "editClient": {
    "changeOrganization": "Changer d'organisation",
    "changeHousehold": "Changer de ménage",
    "removeFromHousehold": "Retirer du ménage",
    "activateClient": "Activer le client",
    "freezeClient": "Geler le client",
    "deactivateClient": "Désactiver le client",
    "copyID": "Copier l'identifiant",
    "freezeClientModal": {
      "title": "Geler le client",
      "bodyText": "Voulez-vous vraiment geler ce client?"
    },
    "deactivateClientModal": {
      "title": "Désactiver le client",
      "bodyText": "Voulez-vous vraiment désactiver ce client?"
    },
    "reactivateClientModal": {
      "title": "Réactiver le client",
      "bodyText": "Voulez-vous vraiment réactiver ce client?"
    }
  },
  "editAccount": {
    "closeAccount": "Fermer le compte",
    "forceOpenAccount": "Forcer l'ouverture du compte",
    "viewStateHistory": "Voir l’historique des états"
  },
  "htmlTemplate": {},
  "rateOfReturns": {
    "portfolio": "Portefeuille",
    "total": "Total",
    "groupOn": {
      "user": "Utilisateur",
      "household": "Ménage",
      "account": "Compte",
      "goal": "Objectif",
      "subAccount": "Sous-compte",
      "accountGroup": "Groupe de comptes"
    },
    "frequency": {
      "oneMonth": "1 mois",
      "threeMonth": "3 mois",
      "sixMonth": "6 mois",
      "oneYear": "1 an",
      "threeYear": "3 ans",
      "fiveYear": "5 ans",
      "yearToDate": "Cumul annuel jusqu'à ce jour",
      "sinceInception": "Depuis le début"
    }
  },
  "nextBestAction": {
    "mainTitle": "Meilleures actions suivantes",
    "title": "Générer les meilleures actions suivantes",
    "description": "À l'aide de l'IA et de l'apprentissage automatique, nous pouvons générer une liste d'actions qui, selon nous, vous aideront à mieux servir vos clients.",
    "generate": "Générer",
    "regenerate": "Générer à nouveau",
    "disclaimerTitle": "Avis de non-responsabilité",
    "disclaimer": "Il s'agit d'une fonctionnalité bêta non destinée à être utilisée à des fins de production. L'exactitude ou l'exhaustivité des actions générées ne sont pas garanties."
  },
  "archivePageModal": {
    "title": "Archive {{pageName}}?",
    "bodyText": "Cette configuration de page va être archivée. Voulez-vous continuer ?"
  },
  "feeWidgetOrgAccountGroupOnly": "Les détails des frais ne sont disponibles que pour les groupes de comptes d'organisation. Sélectionnez un groupe de comptes d'organisation pour prévisualiser ce widget.",
  "addWorkflowTab": {
    "switch": "Activer le flux de travail",
    "label": "Flux de travail",
    "none": "Aucun"
  }
}
